import { ChangeDetectionStrategy, Component } from '@angular/core';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';

import { ToursSearch } from 'package-types';

import { SearchResultStore } from '../../../dynamic-page-container/services/store/search-result.store';
import { SearchResultState } from '../../../dynamic-page-container/services/store/search-result.state';

import ResultStatus = ToursSearch.ResultStatus;

@UntilDestroy()
@Component({
  selector: 'app-tour-offers-content',
  templateUrl: './tour-offers-content.component.html',
  styleUrls: ['./tour-offers-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TourOffersContentComponent {
  hotels$: Observable<ToursSearch.HotelProposal[]> = this.store.onChanges('hotels');
  hasNext$: Observable<boolean> = this.store.onChanges('hasNext');
  isSorting$: Observable<boolean> = this.store.onChanges('isSorting');
  departureCitiesMessage$ = this.store.onChanges('departureCitiesMessage');
  isOffersLoading$ = this.store.state$
    .pipe(
      distinctUntilChanged((prev, next) => (
        prev.page === next.page
        && prev.status === next.status
        && prev.isSorting === next.isSorting
        && prev.hotels.length === next.hotels.length
      )),
      map(({ status, page, isSorting, hotels }) => (
        !isSorting
        && this.isLoadingStatus(status)
        && page === 1
        && hotels.length === 0
      ))
    );
  isSearchContinuationLoading$ = this.store.state$
    .pipe(
      distinctUntilChanged((prev, next) => (
        prev.page === next.page
        && prev.status === next.status
        && prev.hotels.length === next.hotels.length
      )),
      map(({ status, page, hotels }) => this.isLoadingStatus(status) && page === 1 && hotels.length > 0)
    );
  isNextPageLoading$ = this.store.state$
    .pipe(
      distinctUntilChanged((prev, next) => prev.page === next.page && prev.status === next.status),
      map(({ status, page }) => this.isLoadingStatus(status) && page != null && page > 1)
    );

  constructor(private store: SearchResultStore) { }

  loadNextPage(): void {
    this.store.loadNextPage();
  }

  retryDepartureCities(): void {
    this.store.retryDepartureCities();
  }

  private isLoadingStatus(status: SearchResultState['status']) {
    return status === undefined || status === ResultStatus.InProgress || status === ResultStatus.Partial;
  }
}
